"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputLabel = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const capitalize_1 = __importDefault(require("capitalize"));
const helpers_1 = require("../../../lib/helpers");
const InputContext_1 = require("../../../contexts/InputContext");
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const useLabelRetract_1 = __importDefault(require("../../../hooks/Input/useLabelRetract"));
function getInputLabel(label, name) {
    /* Unless label is specifically turned off (setting to '', false), we will use the name as a backup label. */
    if (label === undefined && !!name) {
        label = capitalize_1.default(name.replace(/_/g, ' '));
    }
    return label;
}
exports.getInputLabel = getInputLabel;
const InputLabel = (props) => {
    var _a;
    const inputProps = react_1.useContext(InputContext_1.InputContext);
    const { divRef, name } = inputProps;
    const label = getInputLabel(inputProps.label, name);
    const [retractedLabel] = useLabelRetract_1.default(divRef.current ? divRef.current.querySelector('input') : null, inputProps.value);
    const primitiveProps = helpers_1.usePrimitiveProps(props, { className: classnames_1.default({ retracted: retractedLabel || ((_a = props.className) === null || _a === void 0 ? void 0 : _a.includes('retracted')) }) });
    if (!label) {
        return null;
    }
    return (react_1.default.createElement("div", Object.assign({}, primitiveProps),
        react_1.default.createElement("span", null, label)));
};
exports.default = withJourney_1.default('j-input-label', InputLabel);
